import { render, staticRenderFns } from "./SaleSelectorList.vue?vue&type=template&id=2a898e04&"
import script from "./SaleSelectorList.vue?vue&type=script&lang=js&"
export * from "./SaleSelectorList.vue?vue&type=script&lang=js&"
import style0 from "./SaleSelectorList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports